module.exports = __webpack_public_path__ + "files/SPIADI2020 - Rapport National.e296fcd5c11783b75ac9791f7198d813.pdf";